import React, { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { Caption1 } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { BodyItem } from "./BodyItem.jsx";

export const NewMessageSeparator = React.forwardRef(({ isSingleNewMessage, className, onEnterView, style }, ref) => {
  const { t } = useTranslation();

  const [inViewRef, inView] = useInView({
    threshold: 0.6,
  });

  useEffect(() => {
    if (inView) {
      typeof onEnterView === "function" && onEnterView();
    }
  }, [inView, onEnterView]);

  const setRefs = useCallback(
    (node) => {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref?.current) {
        ref.current = node;
      }
      inViewRef(node);
    },
    [inViewRef, ref]
  );

  return (
    <BodyItem
      ref={setRefs}
      className={classnames("tw-px-0 tw-w-full tw-relative tw-pb-5 tw-justify-center new-message-separator", className)}
      style={style}
    >
      <Caption1
        color="theme-primary"
        className="new-message-separator-text tw-w-full"
      >
        {isSingleNewMessage ? t("New message") : t("New messages")}
      </Caption1>
    </BodyItem>
  );
});

NewMessageSeparator.propTypes = {
  isSingleNewMessage: PropTypes.bool,
  className: PropTypes.string,
  onEnterView: PropTypes.func,
  style: PropTypes.object,
};

NewMessageSeparator.defaultProps = {
  isSingleNewMessage: false,
};

NewMessageSeparator.displayName = "NewMessageSeparator";
